/** Presentation names from yesterday map to current native identities, never old saved UUIDs. */
export function canonicalReportPrototypeId(pageId: string): string {
  if (pageId === 'commercial-kpi') return 'commercial-kpi-tracker';
  if (pageId === 'flash-live-deals-benchmark') return 'flash-funnel';
  return pageId;
}

/** Local review surfaces. Production availability requires a separate release decision. */
export const REPORT_PROTOTYPE_PAGES = [
  { pageId: 'inspiration-blog-performance', path: '/commercial-ops/inspiration-blog-performance' },
  { pageId: 'email-clicks-by-day', path: '/commercial-ops/email-clicks-by-day' },
  { pageId: 'lpc-post-campaign', path: '/commercial-ops/lpc-post-campaign' },
  { pageId: 'flash-supply-forecasts', path: '/commercial-ops/flash-supply-forecasts' },
  { pageId: 'room-inventory-availability', path: '/commercial-ops/room-inventory-availability' },

  { pageId: 'flash-funnel', path: '/commercial-ops/flash-funnel' },
  { pageId: 'contribution-margin', path: '/commercial-ops/contribution-margin' },
  { pageId: 'performance-marketing', path: '/commercial-ops/performance-marketing' },

  {
    pageId: 'commercial-kpi-tracker',
    path: '/commercial-ops/commercial-kpi-tracker',
  },
  {
    pageId: 'countries',
    path: '/commercial-ops/countries',
  },
  {
    pageId: 'customer-comms',
    path: '/commercial-ops/customer-comms',
  },
  {
    pageId: 'flash-post-campaign',
    path: '/commercial-ops/flash-post-campaign',
  },
  {
    pageId: 'luxplus',
    path: '/commercial-ops/luxplus',
  },
] as const;
